import {Fragment, useEffect, useState} from "react";
import {getAll as getEpisodes} from "app/requests/episodes";
import {ActionText, Episode} from "components/helpers";
import {Loading} from "components/pages";
import useAppContext from "lib/hooks/use-app-context";
import useContent from "lib/hooks/use-content";
import useQueryParams from "lib/hooks/use-query-params";
import {queryString} from "lib/object";
import {isBlankHTML} from "lib/string";

export default function Home() {
  const {page} = useAppContext();
  const announcements = useContent("General", "Announcements");
  const cases = useContent("General", "Cases");
  const casesEnabled = useContent("Cases", "Enable Submissions");
  const [episodes, setEpisodes] = useState(null);
  const [pages, setPages] = useState(null);
  const resources = useContent("General", "Resources");
  const sidebar = !!(announcements || resources);
  const params = useQueryParams();
  const [pageNumber, setPageNumber] = useState(+(params.get("page") || 1));
  const limit = +(params.get("limit") || 5);
  const search = params.get("search");
  const updatePage = (e) => {
    e.preventDefault();

    setPageNumber(+new URL(e.currentTarget.href).searchParams.get("page"));
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    getEpisodes({limit, page: pageNumber, search}).then((data) => {
      setEpisodes(data.episodes);
      setPages(data.pages);
    });
  }, [pageNumber]);

  if(!episodes) { return <Loading />; }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className={`col-lg-8 col-xl-6 offset-xl-${sidebar ? 1 : 3}`}>
          {!isBlankHTML(page.content) && (
            <>
              <div className="custom-html text-center">
                <ActionText.Content html={page.content} />
              </div>
              <hr />
            </>
          )}
          {search && (
            <>
              <h3>Showing results for "{search}"</h3>
              <hr />
            </>
          )}
          {episodes.map((episode) => (
            <Fragment key={episode.uid}>
              <Episode episode={episode} />
              <hr />
            </Fragment>
          ))}
          {episodes.length === 0 && <div className="text-center">Nothing found</div>}
          <div className="text-center">Page {pageNumber} of {pages}</div>
          {pages > 1 && (
            <div className="mt-2 text-center">
              <div className="btn-group">
                {pageNumber > 1 ? (
                  <>
                    <a className="btn btn-themed" href={`${window.location.pathname}?${queryString({limit, page: 1, search})}`} onClick={updatePage}>
                      <i className="fas fa-angle-double-left" />
                    </a>
                    <a className="btn btn-themed" href={`${window.location.pathname}?${queryString({limit, page: pageNumber - 1, search})}`} onClick={updatePage}>
                      <i className="fas fa-angle-left" />
                    </a>
                  </>
                ) : (
                  <>
                    <button className="btn btn-themed disabled" type="button">
                      <i className="fas fa-angle-double-left" />
                    </button>
                    <button className="btn btn-themed disabled" type="button">
                      <i className="fas fa-angle-left" />
                    </button>
                  </>
                )}
                <button className="btn btn-themed disabled" type="button">{pageNumber}</button>
                {pageNumber + 1 > pages ? (
                  <>
                    <button className="btn btn-themed disabled" type="button">
                      <i className="fas fa-angle-right" />
                    </button>
                    <button className="btn btn-themed disabled" type="button">
                      <i className="fas fa-angle-double-right" />
                    </button>
                  </>
                ) : (
                  <>
                    <a className="btn btn-themed" href={`${window.location.pathname}?${queryString({limit, page: pageNumber + 1, search})}`} onClick={updatePage}>
                      <i className="fas fa-angle-right" />
                    </a>
                    <a className="btn btn-themed" href={`${window.location.pathname}?${queryString({limit, page: pages, search})}`} onClick={updatePage}>
                      <i className="fas fa-angle-double-right" />
                    </a>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
        {sidebar && (
          <div className="col-lg-4">
            {casesEnabled && !isBlankHTML(cases) && (
              <div className="card border-success my-2">
                <div className="card-header bg-success text-white">Case Submissions</div>
                <div className="card-body custom-html">
                  <ActionText.Content html={cases} />
                  <div className="mt-2 text-center">
                    <a className="btn btn-themed" href="/cases/submissions">Submit Case</a>
                  </div>
                </div>
              </div>
            )}
            {!isBlankHTML(announcements) && (
              <div className="card border-success my-2">
                <div className="card-header bg-success text-white">Announcements</div>
                <div className="card-body custom-html">
                  <ActionText.Content html={announcements} />
                </div>
              </div>
            )}
            {!isBlankHTML(resources) && (
              <div className="card border-success mt-2">
                <div className="card-header bg-success text-white">Cool Sites</div>
                <div className="card-body custom-html">
                  <ActionText.Content html={resources} />
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
